import React from 'react'
import { IconButton } from 'shared/ui'

import { getByline } from './util'

const Header = ({
  action,
  currentUserId,
  isNote,
  isFirstMessage,
  isForward,
  hasAttachments,
  isFromMerge,
  hasRawEmail,
  readReceipt,
  onCopyLinkClick,
  onRawEmailClick,
  onPrintClick,
}) => {
  const datetime = action.datetime

  return (
    <div className="header">
      {getByline({
        action,
        currentUserId,
        isNote,
        isFirstMessage,
        isForward,
      })}

      <div className="right-side">
        <div className="meta">
          {readReceipt && <div className="read-receipt">SEEN</div>}
          <div className="icons">
            {hasAttachments && <div className="Icon Icon-attachment" />}
            {isFromMerge && <div className="Icon Icon-merge" />}
          </div>
          <div className="datetime">{datetime}</div>
        </div>
        <div className="actions hidden-in-print">
          <IconButton
            name="print"
            svg
            onClick={onPrintClick}
            size="small"
            tooltip="Print"
            iconSize={16}
          />
          <IconButton
            name="link"
            svg
            onClick={onCopyLinkClick}
            size="small"
            tooltip={
              <span>
                Copy Link<br />to Message
              </span>
            }
            iconSize={18}
          />
          {hasRawEmail && (
            <IconButton
              name="externalLink"
              svg
              onClick={onRawEmailClick}
              size="small"
              tooltip={
                <span>
                  View<br />Raw Email
                </span>
              }
              iconSize={16}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
